import { Commune, defaultCommune } from './Commune';

export interface Company {
    id: number;
    name: string;
    avatar?: File;
    address: string;
    commune: Commune;
    commune_id: number;
    contact_phone_code: string;
    contact_phone: string;
    email: string;
    website?: string;
    rut: string;
}

export const defaultCompany: Company = {
    commune: defaultCommune,
    commune_id: 0,
    id: 0,
    name: '',
    address: '',
    contact_phone_code: '+56',
    contact_phone: '',
    email: '',
    rut: ''
};
